module.exports = __webpack_public_path__ + "img/Middle-2-Bevel-Attachment-16.f40ff1f0.png";